import { Classes, Colors, IconSize } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

import { IconProps } from 'bones/components/atoms/icons/types';

export const Between: React.VFC<IconProps> = ({
  className,
  color = Colors.DARK_GRAY1,
  size = IconSize.STANDARD,
  title,
}) => (
  <svg
    className={classNames('sd-icon', Classes.ICON, className)}
    fill="none"
    height={size}
    viewBox="0 0 20 20"
    width={size}
  >
    {title ? <title>{title}</title> : null}
    <path
      d="M14.2926 13.7074C14.6827 14.0975 15.3152 14.0975 15.7053 13.7074L18.6677 10.745C18.6812 10.7329 18.6944 10.7204 18.7074 10.7074C18.9027 10.5121 19.0003 10.256 19 10C19.0003 9.744 18.9027 9.48791 18.7074 9.29259C18.6944 9.27962 18.6812 9.26709 18.6677 9.25498L15.7053 6.29259C15.3152 5.90247 14.6827 5.90247 14.2926 6.29259C13.9025 6.68271 13.9025 7.31521 14.2926 7.70533L16.5873 10L14.2926 12.2947C13.9025 12.6848 13.9025 13.3173 14.2926 13.7074Z"
      fill={color}
    />
    <path
      d="M4.29467 13.7074C4.68479 14.0975 5.31729 14.0975 5.70741 13.7074C6.09753 13.3173 6.09753 12.6848 5.70741 12.2947L3.41274 10L5.70741 7.70533C6.09753 7.31521 6.09753 6.68271 5.70741 6.29259C5.31729 5.90247 4.68479 5.90247 4.29467 6.29259L1.33228 9.25498C1.31879 9.26709 1.30556 9.27962 1.29259 9.29259C1.09727 9.48791 0.999741 9.744 1 10C0.999741 10.256 1.09727 10.5121 1.29259 10.7074C1.30556 10.7204 1.31879 10.7329 1.33228 10.745L4.29467 13.7074Z"
      fill={color}
    />
    <path
      d="M0 20V0H0.5C0.77614 0 1 0.447715 1 1V19C1 19.5523 0.77614 20 0.5 20H0Z"
      fill={color}
    />
    <path
      d="M20 20V0H19.5C19.2239 0 19 0.447715 19 1V19C19 19.5523 19.2239 20 19.5 20H20Z"
      fill={color}
    />
    <line stroke={color} strokeWidth="1.5" x1="3" x2="17" y1="10" y2="10" />
  </svg>
);
